import axios from 'axios'
const baseURL = process.env.VUE_APP_API_URL_BASE

const apiRequest = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
    // 'HTTP-X-DAPP-REQUESTTIME': '1556004532',
    // 'HTTP-X-DAPP-USERID': '1',
    // 'HTTP-X-DAPP-AUTHCD': 'ecf2ffc592842b4a70722844eb48d89e67b3fc17c7232792c82c79321e7aa631'
  }
})

apiRequest.interceptors.response.use(
  res => {
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

export default apiRequest
